export { ClearpathComponent } from "./clearpath/clearpath.component";
export {
  SalesPersonWriteupsListComponent
}
  from "./sales-person-writeups-list/sales-person-writeups-list.component";
export { NewDealComponent } from "./new-deal/new-deal.component";
